import React from "react"
import Cabecalho from "../Cabecalho"
import { TabelaPerguntas } from "./components/TabelaPerguntas"

export function PerguntaPesquisaSatisfacao() {
    return (
        <>
            <Cabecalho pagina="Pesquisa de Satisfação" />
            <TabelaPerguntas />
        </>
    )
}
